import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Table } from '@cureskin/api-client';
import { CsIconModule } from '@components/icon';
import { ChatLanguagePillComponent } from '@shared/chat-language-pill/chat-language-pill.component';

@Component({
  selector: 'instruction-header',
  standalone: true,
  imports: [CommonModule, CsIconModule, ChatLanguagePillComponent],
  templateUrl: './instruction-header.component.html',
})
export class InstructionHeaderComponent {
  readonly title = input('');
  readonly showPill = input(false);
  readonly sticky = input(false);
  readonly consultationSession = input<Table.ConsultationSession>();
  readonly botReplyInProgress = input(false);
  readonly translateChatMessages = input(true);
  readonly back = output<void>();
}
